import { createSelector } from 'reselect';

export const skusSelector = (state) => state.get('skus');

export const skusByIdSelector = createSelector(skusSelector, (skus) =>
  skus.get('byId')
);

export const skusAllIdsSelector = createSelector(skusSelector, (skus) =>
  skus.get('allIds')
);

export const skusByProjectIdSelector = createSelector(skusSelector, (skus) =>
  skus.get('byProjectId')
);
